import React, { useState } from "react";
import Map from "../../components/Map/Map";
import AddListing from "../../components/AddListing/AddListing";
import "./AddListingPage.scss";

export default function AddListingPage() {
  const [currentLocation, setLocation] = useState({});

  return (
    <div className="add">
      <div className="add__wrap">
        <Map currentLocation={currentLocation} setLocation={setLocation} />
        <div className="add__content">
          <AddListing
            currentLocation={currentLocation}
            setLocation={setLocation}
          />
        </div>
      </div>
    </div>
  );
}
